import React from 'react';

import { useStockItemCompact } from '../hooks/useStockItemCompact';

export const AIEditButton = ({
  onClick,
  disabled,
}: {
  onClick: () => void;
  disabled: boolean;
}) => {
  const { containerRef } = useStockItemCompact();
  const defaultButtonClassName =
    'bg-gray-900 hover:bg-opacity-90 text-white rounded-full flex items-center justify-center cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-white';

  const disabledButtonClassName =
    'bg-gray-200 text-gray-500 rounded-full flex items-center justify-center cursor-not-allowed';

  return (
    <div ref={containerRef}>
      <style>{`
        @keyframes spin-slow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
      <div className="relative group">
        {!disabled && (
          <>
            <div
              className="absolute rounded-full overflow-hidden opacity-100 group-hover:opacity-0 transition-opacity duration-300"
              style={{
                top: '-2px',
                right: '-2px',
                bottom: '-2px',
                left: '-2px',
              }}
            >
              <div
                className="absolute"
                style={{
                  width: '200%',
                  height: '200%',
                  left: '-50%',
                  top: '-50%',
                  background:
                    'conic-gradient(transparent 0deg, transparent 270deg, rgb(153, 82, 224) 300deg, rgb(250, 227, 215) 330deg, rgb(255, 102, 230) 345deg, transparent 360deg)',
                  animation: 'spin-slow 3s linear infinite',
                }}
              />
            </div>
            <div
              className="absolute rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              style={{
                top: '-2px',
                right: '-2px',
                bottom: '-2px',
                left: '-2px',
                background:
                  'linear-gradient(to right, rgb(153, 82, 224), rgb(250, 227, 215), rgb(255, 102, 230))',
              }}
            />
          </>
        )}
        <button
          disabled={disabled}
          className={`${
            disabled ? disabledButtonClassName : defaultButtonClassName
          } px-3 py-2.5 gap-2 w-full relative`}
          data-cy="ai-edit-button"
          onClick={onClick}
          aria-label="Edit with AI"
        >
          <img
            src={`${__ASSETS_COMMON_IMAGES_URL__}/icons/${
              disabled ? 'ai-wand-disabled.svg' : 'ai-wand.svg'
            }`}
            alt="Edit with AI"
            className="w-4 h-4"
          />
          <span className="text-base font-semibold leading-5 text-nowrap">
            Edit with AI
          </span>
        </button>
      </div>
    </div>
  );
};
